@if (isVisible) {
  <div class="grid-x full-width" [formGroup]="formGroup"  >
    <form-control-label [question]="componentData"></form-control-label>
    <div class="grid-x full-width bold">
      Signature:
    </div>
    <div class="grid-x full-width">
      <div class="signature-box">
        <input id="isig" type="text" [(ngModel)]="contextValue" [formControlName]="componentData.key"  />
      </div>
      <div class="bold">
        Electronic Signature
      </div>
    </div>
    <div class="grid-x full-width legal-footer vertical-spacing">
      <span name="legalFooter" [innerHTML]="componentData.config.display.legalFooter | safeHtml"></span>
    </div>
    <p class="vertical-spacing">
      Please select your response to the following statement: By selecting "I agree", I hereby affix my electronic signature.  I agree to be bound, in all respects, as if I were affixing my handwritten signature to the document.
    </p>
    <div class="grid-x full-width radio-line">
      <label>
        <input type="radio" value="agree" [checked]="agreeChecked()" (click)="storeConsent('agree')" /> I Agree
      </label>
    </div>
    <div class="grid-x full-width radio-line">
      <label>
        <input type="radio" value="decline" [checked]="declineChecked()" (click)="storeConsent('decline')" /> I Disagree
      </label>
    </div>
  </div>
}
@if (isEdit && !hasValidation()) {
  <div class="builder-warning">
    No Signature validation applied.
  </div>
}
